import { APP_STOCK_SETTING } from "../../constants/app";
import BankIcon from '../../assets/images/icons/myacc_icon_bank.png';
import {
  sendMsg,
  ENDPOINT_REQUEST as userServicesRequest,
  SERVICES_REQUEST as services
} from '../../configurations';
import { PARAMS as paramsRq } from '../../constants/params';

export const userServices = {
  updateAccountInformationService,
  getPreferencesService,
  updatePreferencesService,
  getAlertService,
  updateAlertService,
  getBankAccountService,
  getWatchlistService,
  manageWatchlistService,
  getQuoteHistoryService,
  manageQuoteHistoryService,
  getInstrumentWatchlistService,
  addNewWatchlistService,
  deleteWatchlistService,
  getHotTopInstrumentService,
  getMarketReportTypeService, 
  getMarketPostService,
  getMarketAttachPostService,
  getMarketCommentSendReportService,
  getPostListService,
  postSubscribe,
  postUnsubscribe,
  getMakrketCommentReplyService,
  getMakrketCommentPostDetailService,
  updateUserPreferencesService,
  getseriesProductEnquiry,
  grtVirtualWatchlistService,
  grtVirtualUserInfoService,
  grtVirtualTradingAccountService,
  grtVirtualRankingService,
  grtVirtualCompetitionListService,
  grtVirtualPortfoliosService,
  grtVirtualManageWatchlistService,
  grtVirtualOrderEnquiryService,
  grtVirtualCreatWatchlist,
  updateAccountBankService
}

function updateAccountInformationService(params, callback) {
  sendMsg(services.AUTH, userServicesRequest.iAUTH.USER_UPDATE_INFO.format(params.userID), params).post(res => {
    callback(res);
  })
}

function getPreferencesService(params, callback) {
  sendMsg(services.WIN_VEST, userServicesRequest.wUSER.GET_PREFERENCES.format(params.uuid), params).get(res => {
    callback(res);
  })
}

function updateUserPreferencesService(params, callback) {
  sendMsg(services.WIN_VEST, userServicesRequest.wUSER.PREFERENCE.format(params.uuid), params).put(res => {
    callback(res);
  })
}

function updatePreferencesService(params, callback) {
  sendMsg(services.WIN_VEST, userServicesRequest.wUSER.UPDATE_PREFERENCES, params).post(res => {
    callback(res);
  })
}

function getAlertService(params, callback) {
  const res = {
    "code": 4,
    "status": "ST200",
    "result": {
      "errorCode": "OLS0000",
      "errorMessage": "Logout Success",
      mainResult: [
        { id: 1, marketId: 1, stockCode: 'HK.00001', stockName: 'CKH Holding', currentPrice: 1.800, changePercent: 0.60, changeValue: 0.470, priceRise: 1.900, priceFall: 1.600 },
        { id: 2, marketId: 1, stockCode: 'HK.00002', stockName: 'Vinamilk', currentPrice: 0.900, changePercent: -0.80, changeValue: -0.787, priceRise: 1.300, priceFall: 0.700 },
        { id: 3, marketId: 1, stockCode: 'HK.00003', stockName: 'ACB', currentPrice: 1.787, changePercent: 0.00, changeValue: 0.00, priceRise: 1.900, priceFall: 1.600 },
        { id: 31, marketId: 1, stockCode: 'HK.00003', stockName: 'ACB', currentPrice: 1.787, changePercent: 0.00, changeValue: 0.00, priceRise: 1.900, priceFall: 1.600 },
        { id: 32, marketId: 1, stockCode: 'HK.00003', stockName: 'ACB', currentPrice: 1.787, changePercent: 0.00, changeValue: 0.00, priceRise: 1.900, priceFall: 1.600 },
        { id: 33, marketId: 1, stockCode: 'HK.00003', stockName: 'ACB', currentPrice: 1.787, changePercent: 0.00, changeValue: 0.00, priceRise: 1.900, priceFall: 1.600 },
        { id: 34, marketId: 1, stockCode: 'HK.00003', stockName: 'ACB', currentPrice: 1.787, changePercent: 0.00, changeValue: 0.00, priceRise: 1.900, priceFall: 1.600 },
        { id: 35, marketId: 1, stockCode: 'HK.00003', stockName: 'ACB', currentPrice: 1.787, changePercent: 0.00, changeValue: 0.00, priceRise: 1.900, priceFall: 1.600 },
        { id: 4, marketId: 2, stockCode: 'SH.00004', stockName: 'CKH Holding', currentPrice: 1.800, changePercent: 0.60, changeValue: '+0.470', priceRise: 1.900, priceFall: 1.600 },
        { id: 5, marketId: 3, stockCode: 'EX.00005', stockName: 'CKH Holding', currentPrice: 1.800, changePercent: 0.60, changeValue: '+0.470', priceRise: 1.900, priceFall: 1.600 },
        { id: 6, marketId: 3, stockCode: 'EX.00006', stockName: 'CKH Holding', currentPrice: 1.800, changePercent: 0.60, changeValue: '+0.470', priceRise: 1.900, priceFall: 1.600 },
      ]
    }
  }
  setTimeout(() => {
    callback(res);
  }, 1000);
}

function updateAlertService(params, callback) {
  const res = {
    "code": 3,
    "status": "ST200",
    "result": {
      "errorCode": "OLS0000",
      "errorMessage": "Update Alert Success"
    }
  }
  callback(res)
}

function getBankAccountService(params, callback) {
  sendMsg(services.EQT, userServicesRequest.iTRADE.CLIENT.GET_BANK_ACCOUNT.format(params[paramsRq.CLIENT_ID]), params).get(res => {
    setTimeout(() => {
      callback(res);
    }, 1000);
  })
}

function getWatchlistService(params, callback) {
  sendMsg(services.WIN_VEST, userServicesRequest.wAUTH.WIN_VEST_ENQUIRY_WATCHLIST.format(params.uuid)).get(res => {
    callback(res);
  })
}

function manageWatchlistService(params, callback) {
  sendMsg(services.WIN_VEST, userServicesRequest.wAUTH.WIN_VEST_MANAGE_WATCHLIST, params).put(res => {
    callback(res);
  })
}

function getQuoteHistoryService(params, callback) {
  sendMsg(services.WIN_VEST, userServicesRequest.wAUTH.WIN_VEST_ENQURY_QUETO_HISTORY.format(params.uuid),params).get(res => {
    callback(res);
  })
}

function manageQuoteHistoryService(params, callback) {
  sendMsg(services.WIN_VEST, userServicesRequest.wFORUM.SEARCH_HISTORY,params).post(res => {
    callback(res);
  })
}

function getInstrumentWatchlistService(params, callback) {
  sendMsg(services.WIN_VEST, userServicesRequest.wAUTH.WIN_VEST_ENQUIRY_WATCHLIST.format(params.uuid), params).get(res => {
    callback(res);
  })
}

function addNewWatchlistService(params, callback) {
  sendMsg(services.WIN_VEST, userServicesRequest.wAUTH.WIN_VEST_CREATE_WATCHLIST, params).post(res => {
    callback(res);
  })
}

function deleteWatchlistService(params, callback) {
  sendMsg(services.WIN_VEST, userServicesRequest.wAUTH.WIN_VEST_DELETE_WATCHLIST.format(params.name), params).delete(res => {
    callback(res);
  })
}

function getHotTopInstrumentService(params, callback) {
  sendMsg(services.WIN_VEST, userServicesRequest.wFORUM.SEARCH_MARKET_ACTIVE,params).get(res => {
    callback(res);
  })
}

function getMarketReportTypeService(params, callback) {
  sendMsg(services.WIN_VEST, userServicesRequest.wFORUM.REPORT_TYPE,params).get(res => {
    callback(res);
  })
}

function getMarketPostService(params, callback) {
  sendMsg(services.WIN_VEST, userServicesRequest.wFORUM.MARKET_POST,params).post(res => {
    callback(res);
  })
}

function getMarketAttachPostService(params, nid, callback) {
  sendMsg(services.WIN_VEST, userServicesRequest.wFORUM.ATTACH_FILE_TO_POST.format(nid), params).post(res => {
    callback(res);
  })
}

function getMarketCommentSendReportService(params, callback) {
  sendMsg(services.WIN_VEST, userServicesRequest.wFORUM.SPEECH_REPORT, params).post(res => {
    callback(res);
  })
}

function getPostListService(params, callback) {
  sendMsg(services.WIN_VEST, userServicesRequest.wAUTH.WIN_VEST_POST_LIST.format(params.uuid),params).get(res => {
    callback(res);
  })
}

function postSubscribe(params, callback) {
  sendMsg(services.WIN_VEST, userServicesRequest.wAUTH.WIN_VEST_SUBSCRIBE.format(params.id),params).post(res => {
    callback(res);
  })
}

function postUnsubscribe(params, callback) {
  sendMsg(services.WIN_VEST, userServicesRequest.wAUTH.WIN_VEST_UNSUBSCRINE.format(params.id),params).post(res => {
    callback(res);
  })
}

function getMakrketCommentReplyService(params, callback) {
  sendMsg(services.WIN_VEST, userServicesRequest.wFORUM.MARKET_COMMENT_REPLY.format(params.cid),params).post(res => {
    callback(res);
  })
}

function getMakrketCommentPostDetailService(params, callback) {
  sendMsg(services.WIN_VEST, userServicesRequest.wFORUM.MARKET_COMMENT_POST_DETAIL.format(params.nid),params).get(res => {
    callback(res);
  })
}

function getseriesProductEnquiry(params, callback) {
  sendMsg(services.EQT, userServicesRequest.wFORUM.SERIES_PRODUCT, params).get(res => {
    callback(res)
  })
}

function grtVirtualWatchlistService(params,callback){
  sendMsg(services.WIN_VEST,userServicesRequest.wAUTH.VIRTUAL_TRADING_WATCHLIST.format(params.uuid),params).get(res => {
      callback(res);
  })
}

function grtVirtualUserInfoService(params,callback){
  sendMsg(services.WIN_VEST,userServicesRequest.wAUTH.VIRTUAL_TRADING_USER_INFO.format(params.uuid),params).get(res => {
      callback(res);
  })
}

function grtVirtualTradingAccountService(params,callback){
  sendMsg(services.WIN_VEST,userServicesRequest.wAUTH.VIRTUAL_TRADING_TRADING_ACCOUNT.format(params.sub_id),params).get(res => {
      callback(res);
  })
}

function grtVirtualRankingService(params,callback){
  sendMsg(services.WIN_VEST,userServicesRequest.wAUTH.VIRTUAL_TRADING_RANKING.format(params.id),params).get(res => {
      callback(res);
  })
}

function grtVirtualCompetitionListService(params,callback){
  sendMsg(services.WIN_VEST,userServicesRequest.wAUTH.VIRTUAL_TRADING_COMPETITION_LIST.format(params.id),params).get(res => {
      callback(res);
  })
}

function grtVirtualPortfoliosService(params,callback){
  sendMsg(services.WIN_VEST,userServicesRequest.wAUTH.VIRTUAL_TRADING_PORTFOLIOS.format(params.id),params).get(res => {
      callback(res);
  })
}

function grtVirtualManageWatchlistService(params,callback){
  sendMsg(services.WIN_VEST,userServicesRequest.wAUTH.VIRTUAL_TRADING_MANAGE_WATCHLIST,params).put(res => {
      callback(res);
  })
}

function grtVirtualOrderEnquiryService(params,callback){
  sendMsg(services.WIN_VEST,userServicesRequest.wAUTH.VIRTUAL_TRADING_ORDER_ENQUIRY,params).post(res => {
      callback(res);
  })
}

function grtVirtualCreatWatchlist(params,callback){
  sendMsg(services.WIN_VEST,userServicesRequest.wAUTH.VIRTUAL_TRADING_CREAT_WATCHLIST,params).post(res => { 
      callback(res);
  })
}

function updateAccountBankService(params, callback) {
	sendMsg(services.EQT, userServicesRequest.iTRADE.CLIENT.UPDATE_BANK_ACCOUNT, params).post((res) => {
		callback(res);
	});
}